<style lang="less">
</style>

<template>
<div>
  <el-form-item
        label="链接类型"
        :required="false"
        prop="srcType"
        style="width: 600px;"
      >
        <el-select
          v-model="form.srcType"
          style="width: 100%"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in srcType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="form.srcType">
        <el-form-item
          label=""
          :required="false"
          prop="miniType"
          style="width: 600px;"
          v-if="form.srcType === 2"
        >
          <el-radio-group v-model="form.miniType">
            <el-radio
              v-for="(item, index) in miniType"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.miniType === 1 && form.srcType === 2"
          label="APPID"
          prop="appId"
          style="width: 600px;"
        >
          <el-input v-model="form.appId"></el-input>
        </el-form-item>

        <el-form-item v-if="form.srcType !== 3" label="链接地址" prop="linkSrc" style="width: 600px;">
          <el-input v-model="form.linkSrc"></el-input>
        </el-form-item>
      </div>
</div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showContact: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      //如果showContact为true，则显示在线客服
      srcType: this.showContact ? [
        { value: 1, label: "HTML链接" },
        { value: 2, label: "小程序链接" },
        { value: 3, label: "在线客服"}
      ] : [
        { value: 1, label: "HTML链接" },
        { value: 2, label: "小程序链接" },
      ],
      miniType: [
        { value: 1, label: "外部小程序" },
        { value: 2, label: "内部小程序" },
      ],
    }
  }
};
</script>
